import { render, staticRenderFns } from "./FeedNsfwNotice.vue?vue&type=template&id=9a4d57e0&scoped=true&"
import script from "./FeedNsfwNotice.vue?vue&type=script&lang=ts&"
export * from "./FeedNsfwNotice.vue?vue&type=script&lang=ts&"
import style0 from "./FeedNsfwNotice.vue?vue&type=style&index=0&id=9a4d57e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4d57e0",
  null
  
)

export default component.exports